import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: number;
  title: string;
  slug: string;
  coverImage: string;
  excerpt: string;
  category: string;
  author: string;
  publishDate: string;
  readTime: string;
  tags: string[];
}

export default function ArticleCard({
  id,
  title,
  slug,
  coverImage,
  excerpt,
  category,
  author,
  publishDate,
  readTime,
  tags,
}: ArticleCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.01] cursor-pointer"
    >
      <div className="aspect-[16/9] overflow-hidden">
        <img
          src={coverImage}
          alt={title}
          title={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
      </div>
      <div className="p-5">
        <div className="flex items-center gap-3 mb-2">
          <span className="inline-block bg-accent-100 text-accent-700 text-xs font-medium px-2.5 py-1 rounded-full whitespace-nowrap">
            {category}
          </span>
          <span className="text-xs text-foreground-500 whitespace-nowrap">{readTime}</span>
        </div>
        <h3 className="text-foreground-900 font-heading font-semibold text-lg group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
          {title}
        </h3>
        <p className="mt-2 text-sm text-foreground-600 line-clamp-2 leading-relaxed">
          {excerpt}
        </p>
        <div className="flex items-center justify-between mt-4 pt-3 border-t border-background-200/70">
          <div className="flex items-center gap-2 text-xs text-foreground-500">
            <span className="whitespace-nowrap">{author}</span>
            <span>·</span>
            <span className="whitespace-nowrap">{publishDate}</span>
          </div>
          <div className="flex flex-wrap gap-1">
            {tags.slice(0, 2).map((tag) => (
              <span
                key={tag}
                className="inline-block bg-secondary-100 text-secondary-700 text-xs px-2 py-0.5 rounded whitespace-nowrap"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </Link>
  );
}